import { BatchTableColumn } from '@app/sharedModule/models/paginated-batch-table.model';

/**
 * Column configuration for the Add to Batch dialog table.
 * Includes addtobatch action column.
 */
export const ADD_TO_BATCH_TABLE_COLUMNS: BatchTableColumn[] = [
  { name: '', key: 'name', minWidth: '120px', maxWidth: '1fr' },
  { name: 'Batch details', key: 'packages', maxWidth: '1fr' },
  { name: 'Pickup', key: 'pickup', maxWidth: '1fr' },
  { name: 'Fulfillment status', key: 'status', minWidth: '120px', maxWidth: '1fr' },
  { name: 'Owner', key: 'owner', minWidth: '50px', maxWidth: '0.5fr', readonly: true },
  { name: 'Label status', key: 'labels', minWidth: '120px', maxWidth: '1fr' },
  { name: '', key: 'addtobatch', minWidth: '140px', maxWidth: '140px' },
];
